export default "__VITE_ASSET__eVhr6KV6__"